import consts from "@/consts"
import {getApiProps, updateObjectByDiff} from "@/lib/lib";

const changedField = 'changed__time'

export default {
    state: {
        sensorsFullLoad: false,
        sensorsLiteLoad: false,
        sensors: {},
    },
    actions: {
        fetchSensors({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchSensors', args, time: Date.now() / 1000})

                const params = getApiProps('sensors', args)
                this.$api.sensors.getAllGlobal(params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error)
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchSensors', args, inprogress: false})
                    })
            })
        },

        fetchSensorsAll({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('fetchSensors', {'page': 1, 'page-size': consts.querySettings.pageSize})
                    .then((data) => {
                        commit('updateSensors', data)
                        commit('setSensorsLiteLoad', true)
                        commit('setSensorsFullLoad', true)
                        dispatch('setLastCall', {name: 'fetchSensorsChanged', time: Date.now() / 1000})
                        resolve(Array.isArray(data) ? data.length : 0)
                    })
                    .catch((error) => {
                        console.error('[fetchSensorsAll] fetchSensors failed:', error)
                        reject(error)
                        setTimeout(() => {
                            dispatch('fetchSensorsAll')
                        }, 60 * 1000)
                    })
            })
        },

        fetchSensorsAllPages({dispatch, commit, getters}) {
            dispatch('setLastCall', {name: 'fetchSensorsChanged', time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                resolve([])
            })
                .finally(() => {
                    commit('setSensorsFullLoad', true)
                    dispatch('setLastCall', {name: 'fetchSensorsChanged', inprogress: false})
                })
        },

        fetchSensorsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isSensorsFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchSensorsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchSensors', args)
                .then((data) => {
                    commit('updateSensors', data)
                    return dispatch('fetchSensors', {fields: 'id'})
                })
                .then((data) => {
                    commit('filterSensors', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchSensorsChanged', args, inprogress: false})
                })
        },

        saveSensor({dispatch}, sensor) {
            const fn = sensor.id ? 'updateSensor' : 'createSensor'
            return dispatch(fn, sensor)
        },
        createSensor({commit, dispatch}, sensor) {
            return new Promise((resolve, reject) => {
                this.$api.sensors.create(sensor)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateSensor', response.data)
                            dispatch('fetchUnitLmsg', {unitId: response.data.id_unit, 'filter[changed]': 0}).catch(() => {})
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        updateSensor({commit, dispatch}, sensor) {
            return new Promise((resolve, reject) => {
                const id = sensor.id; delete sensor.id;
                this.$api.sensors.update(id, sensor)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateSensor', response.data)
                            dispatch('fetchUnitLmsg', {unitId: response.data.id_unit, 'filter[changed]': 0}).catch(() => {})
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        deleteSensor({commit}, {id}) {
            return new Promise((resolve, reject) => {
                this.$api.sensors.delete(id)
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteSensor', id)
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
    },
    mutations: {
        setSensorsFullLoad(state, fullLoad) {
            state.sensorsFullLoad = state.sensorsFullLoad || fullLoad
        },
        setSensorsLiteLoad(state, liteLoad) {
            state.sensorsLiteLoad = state.sensorsLiteLoad || liteLoad
        },
        updateSensors(state, nSensors) {
            if (!Object.keys(state.sensors).length) {
                state.sensors = nSensors.reduce((byId, s) => {
                    byId[s.id] = s
                    return byId
                }, {})
                return
            }
            nSensors.forEach((nSensor) => {
                const sensor = state.sensors[nSensor.id]
                if (!sensor) {
                    state.sensors[nSensor.id] = nSensor
                } else if (!state.sensorsFullLoad || sensor[changedField] !== nSensor[changedField]) {
                    updateObjectByDiff(sensor, nSensor)
                }
            })
        },
        updateSensor(state, nSensor) {
            const sensor = state.sensors[nSensor.id]
            if (!sensor) {
                state.sensors[nSensor.id] = nSensor
            } else {
                updateObjectByDiff(sensor, nSensor)
            }
        },
        filterSensors(state, nSensors) {
            const nIds = nSensors.map(s => s.id)
            Object.keys(state.sensors).forEach(id => {
                if (!nIds.includes(+id)) {
                    delete state.sensors[id]
                }
            })
        },
        deleteSensor(state, id) {
            delete state.sensors[id]
        },
        clearSensors(state) {
            state.sensors = {}
            state.sensorsFullLoad = false
            state.sensorsLiteLoad = false
        },
    },
    getters: {
        isSensorsFullLoad(state) {
            return state.sensorsFullLoad
        },
        isSensorsLiteLoad(state) {
            return state.sensorsLiteLoad
        },
        getSensors(state) {
            return Object.values(state.sensors)
        },
        getSensorsByIds(state) {
            return state.sensors
        },
        getSensorsByUnitId(state) {
            return Object.values(state.sensors).reduce((byUnitId, sensor) => {
                const unitId = sensor.id_unit
                if (!byUnitId[unitId]) byUnitId[unitId] = []
                byUnitId[unitId].push(sensor)
                return byUnitId
            }, {})
        },
    }
}
